import React from "react";

const features = [
  {
    icon: "🎮",
    title: "Interactive Learning",
    desc: "AI-powered lessons that adapt to your level and pace."
  },
  {
    icon: "👨‍🏫",
    title: "Expert-Crafted Content",
    desc: "Built with financial educators, powered by AI insight."
  },
  {
    icon: "🕹️",
    title: "Live Chart Practice",
    desc: "Apply what you learn instantly with AI feedback."
  },
  {
    icon: "⏱️",
    title: "Your Schedule, Your Way",
    desc: "Bite-sized learning and daily AI tips — on demand."
  },
  {
    icon: "✨",
    title: "No Fluff, Just Clarity",
    desc: "Every lesson, tool, and agent has a job: to simplify."
  },
  {
    icon: "📱",
    title: "Built For Mobile",
    desc: "Learn, ask, and act from anywhere with our iOS + Android apps."
  }
];

const FeaturesSection = () => (
  <section id="features" className="features">
    <div className="container">
      <h2>Built To Help You Learn Faster</h2>
      <div className="features-grid">
        {features.map((feature, i) => (
          <div className="feature-item" key={i}>
            <span className="icon-placeholder">{feature.icon}</span>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
